import safe from 'safe-await'

export async function startDispatch(carId, payload) {
  const [error, response] = await safe(window.axios.post(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/startdispatch/${carId}`, payload))

  return error ? [error] : [error, response.data]
}

export async function stopDispatch(carId) {
  const [error, response] = await safe(window.axios.get(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/stopdispatch/${carId}`))

  return error ? [error] : [error, response.data]
}

export async function makeDispatchPackageSelectionEditable(dispatchId) {
  const [error, response] = await safe(window.axios.post(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/makedispatchpackageselectioneditable/${dispatchId}`))

  return error ? [error] : [error, response.data]
}

export async function confirmCashPayment(dispatchId) {
  const [error, response] = await safe(window.axios.post(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/confirmcashpayment/${dispatchId}`))

  return error ? [error] : [error, response.data]
}

export async function resetDispatch(dispatchId) {
  const [error, response] = await safe(window.axios.post(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/resetdispatch/${dispatchId}`))

  return error ? [error] : [error, response.data]
}

export async function getPackages() {
  const [error, response] = await safe(window.axios.post(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/getpackages`))

  return error ? [error] : [error, response.data]
}

export async function updateDispatchPackages(dispatchId, payload) {
  const [error, response] = await safe(window.axios.post(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/updatedispatchpackages/${dispatchId}`, payload))

  return error ? [error] : [error, response.data]
}

export async function updateContactEmail(dispatchId, payload) {
  const [error, response] = await safe(window.axios.post(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/updatecontactemail/${dispatchId}`, payload))

  return error ? [error] : [error, response.data]
}

export async function checkCurrentState(dispatchId) {
  const [error, response] = await safe(window.axios.get(`${process.env.VUE_APP_PROVIDER}/customerportalmanager/checkcurrentstate/${dispatchId}`))

  return error ? [error] : [error, response.data]
}

export default {
  checkCurrentState,
  confirmCashPayment,
  getPackages,
  makeDispatchPackageSelectionEditable,
  resetDispatch,
  startDispatch,
  stopDispatch,
  updateContactEmail,
  updateDispatchPackages
}
